import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getAtBatState } from '../store/selectors/getAtBat';
import { resourcePath } from '@gameday/utils/resource-path';
import Share from '../../Share/Share';
import { getLanguagePath } from '@gameday/utils/languageHelpers';

const trackingConfig = {
    componentName: ['AtBat', 'Share Button'],
    text: 'AtBat Detail'
};

const getShareUrl = (language, gamePk, playIndex) => {
    return resourcePath.get('atBatShareUrl', {
        languagePath: getLanguagePath(language),
        gamePk,
        id: playIndex
    });
};

const AtBatShareDataContainer = ({
    playIndex
}) => {
    const atBatState = useSelector(getAtBatState(playIndex));
    const {
        language,
        gamePk
    } = atBatState;

    const url = getShareUrl(language, gamePk, playIndex);

    return (
        <Share
            size={'xs'}
            url={url}
            trackingConfig={trackingConfig}
        />
    );
};

AtBatShareDataContainer.propTypes = {
    playIndex: PropTypes.number.isRequired
};

export default AtBatShareDataContainer;
